import type { PermissionCategory } from "components/team/Roles/helpers/customRolesApi";

export const PERMISSION_CATEGORIES_GET_REQUEST =
  "PERMISSION_CATEGORIES_GET_REQUEST";
export const PERMISSION_CATEGORIES_GET_REQUEST_SUCCESS =
  "PERMISSION_CATEGORIES_GET_REQUEST_SUCCESS";
export const PERMISSION_CATEGORIES_GET_REQUEST_FAILURE =
  "PERMISSION_CATEGORIES_GET_REQUEST_FAILURE";
export const PERMISSION_CATEGORIES_GET_RESET =
  "PERMISSION_CATEGORIES_GET_RESET";

export interface RequestAction {
  type: typeof PERMISSION_CATEGORIES_GET_REQUEST;
}
export interface RequestSuccessAction {
  type: typeof PERMISSION_CATEGORIES_GET_REQUEST_SUCCESS;
  data: PermissionCategory[];
}
export interface RequestFailureAction {
  type: typeof PERMISSION_CATEGORIES_GET_REQUEST_FAILURE;
  error: Error;
}
export interface ResetAction {
  type: typeof PERMISSION_CATEGORIES_GET_RESET;
}

export type PermissionCategoriesGetAction =
  | RequestAction
  | RequestSuccessAction
  | RequestFailureAction
  | ResetAction;

export const request = (): RequestAction => ({
  type: PERMISSION_CATEGORIES_GET_REQUEST,
});

export const requestSuccess = (
  data: PermissionCategory[]
): RequestSuccessAction => ({
  type: PERMISSION_CATEGORIES_GET_REQUEST_SUCCESS,
  data,
});

export const requestFailure = (error: Error): RequestFailureAction => ({
  type: PERMISSION_CATEGORIES_GET_REQUEST_FAILURE,
  error,
});

/**
 * Invalidate the cache so the next consumer triggers a fresh fetch.
 * Dispatch on sign-out, tenant switch, or when permission catalog changes.
 */
export const reset = (): ResetAction => ({
  type: PERMISSION_CATEGORIES_GET_RESET,
});
